import { statsOnWidgetInteraction } from './stats';

export const owlSlider = () => {
  $('.owl-carousel').each(function () {
    const $owl = $(this);

    // Przypisz indeksy tylko nieklonowanym elementom
    $owl.find('.owl-item:not(.cloned)').each(function (n) {
      $(this).attr('data-idx', n);
    });

    // Obsługa kliknięcia next/prev
    $owl.find('.owl-next, .owl-prev').on('click', function (e) {
      e.preventDefault();
      // Poczekaj aż carousel przeskoczy i wtedy pobierz indeks
      setTimeout(() => {
        const carousel = $(this).closest('.owl-carousel').data('owl.carousel');
        if (!carousel) return;

        const idx = carousel.relative(carousel.current());
        // const item = carousel.$stage.children().not('.cloned').eq(idx);
        // const src = item.find('img').attr('src') || '';
        const items = carousel.$stage.children().not('.cloned');
        const item = items.eq(idx);

        if (item.length === 0) {
          console.warn('[owlSlider] Nie znaleziono elementu owl-item dla idx:', idx);
          return;
        }

        const src = item.find('img').attr('src') || '';

        const isMobile = window.matchMedia('(pointer: coarse)').matches;
        const eventType = isMobile ? 'tap' : 'click';

        if (item.length) {
          statsOnWidgetInteraction(item[0], src, idx, eventType);
        }
      }, 100); // lekka zwłoka, żeby carousel zdążył zaktualizować
    });
  });

  // Obsługa przeciągnięcia
  $('.owl-carousel').on('dragged.owl.carousel', function (event) {
    const carousel = $(this).data('owl.carousel');
    if (!carousel) return;

    const idx = carousel.relative(carousel.current());
    const item = carousel.$stage.children().not('.cloned').eq(idx);
    const src = item.find('img').attr('src') || '';

    if (item.length) {
      statsOnWidgetInteraction(item[0], src, idx, 'swipe');
    }
  });
};
